import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {WebToAppCtaModuleController} from "../web-to-app-cta-module.controller";

export class WebToAppCtaModuleProps extends BaseModuleProps {
  controller: WebToAppCtaModuleController;
}
